import { BaseToolbarNavPageLayout } from './baseLayoutViews';
import { MobileNotificationView } from './MobileNotificationView';

/**
 * A Backbone wrapper for a React page. This acts as a compatibility layer between
 * our Backbone app + navigation system and newer React pages.
 */
export const ReactPageWrapper = BaseToolbarNavPageLayout.extend({
    // Marker class so global chrome (e.g. the rebrand warning banner) can offset
    // these React pages, which render their own toolbar instead of a .toolbarnav.
    className: 'react_page',
    use_transitions: true,
    renderFunction: () => {},

    initialize: function (options = {}) {
        $.extend(this, options);
        this.toolbarnav_class = null; // the React page should implement its own toolbarnav
    },

    render: function () {
        // React pages render their own toolbar, so we skip the base render (which builds the
        // .toolbarnav). Mount the React tree first: mountReactJSX uses ReactDOM.createRoot, which
        // clears this.el on its initial render.
        window.mountReactJSX(this.el, () => this.renderFunction());

        // Add the legacy toast_notification region as a sibling of the React root. React only
        // manages its own subtree, so it leaves this node in place across re-renders. This keeps
        // the legacy toast system (getActiveToastView / toastNotification) working while a React
        // page is the active view — without it getActiveToastView() resolves to this page, reads
        // an undefined `notification`, and throws (e.g. saving a form draft opened from a
        // follow-up action).
        if (this.$el.children('.toast_notification').length === 0) {
            this.$el.prepend('<div class="toast_notification"></div>');
        }
        this.notification = new MobileNotificationView({
            el: this.$el.children('.toast_notification').get(0),
            $el: this.$el.children('.toast_notification'),
            parent_page: this
        }).render();
    },

    onClose: function () {
        if (this.notification) {
            this.notification.close();
        }
        window.unmountReact(this.el);
    }
});
